import JsBarcode from "jsbarcode";

import { loadHtmlIntoWindow } from "@/lib/pdf";
const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
export function generateBarcodeSvg(value) {
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  try {
    JsBarcode(svg, value, { format: "CODE128", width: 1.2, height: 24, margin: 0, displayValue: false });
    return svg.outerHTML;
  } catch (e) { return `<div>${value}</div>`; }
}

export function printLabels(items) {
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  const cards = items.map((i) => `
    <div class="label">
      <div class="loc">${esc(i.location || "—")}</div>
      <div class="body">
        <div class="name" title="${esc(i.name || "")}">${esc(i.name || "")}</div>
        ${i.name_ar ? `<div class="name_ar" dir="rtl">${esc(i.name_ar)}</div>` : ""}
        <div class="meta">${esc(i.sku || "")}</div>
        <div class="bc">${generateBarcodeSvg(i.barcode || i.sku)}</div>
      </div>
    </div>`).join("");
  loadHtmlIntoWindow(w, `<!doctype html><html><head><title>Labels · ${items.length} parts</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@600;700&display=swap" rel="stylesheet">
    <style>
      @page { margin: 6mm; size: A4; }
      body { font-family: -apple-system, Helvetica, Arial, sans-serif; margin: 0; padding: 6px; color: #111; background: #fff; }
      .toolbar { text-align:center; margin-bottom: 8px; }
      .toolbar button { padding:6px 14px; font-size:12px; border:1px solid #333; background:#fff; border-radius:4px; cursor:pointer; }
      .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
      .label { border: 1px solid #999; border-radius: 4px; page-break-inside: avoid; display:flex; overflow:hidden; min-height: 26mm; }
      .label .loc { width: 18mm; flex:none; background:#000; color:#fff; display:flex; align-items:center; justify-content:center; font-weight: 900; font-size: 18pt; line-height:1; padding: 0 2px; text-align:center; word-break: break-all; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .label .body { flex:1; min-width:0; padding: 5px 6px; display:flex; flex-direction:column; text-align:left; }
      .label .name { font-size: 11pt; font-weight: 800; line-height: 1.1; max-height: 2.2em; overflow:hidden; }
      .label .name_ar { font-family: 'Cairo', 'Amiri', 'Traditional Arabic', sans-serif; font-size: 10pt; font-weight: 700; color: #222; direction: rtl; }
      .label .meta { font-size: 11pt; font-weight: 700; margin-top: auto; font-family: "Courier New", monospace; }
      .label .bc svg { height: 7mm; width: auto; max-width: 100%; display:block; margin-top: 2px; }
      @media print { .no-print { display: none; } }
    </style>
    </head><body>
    <div class="toolbar no-print">
      <span style="font-family:monospace;font-size:11px;color:#666;margin-right:12px">${items.length} labels · A4</span>
      <button onclick="window.print()">🖨 Print</button>
    </div>
    <div class="grid">${cards}</div>
    </body></html>`);
  // Give the Cairo webfont a beat to load so Arabic glyphs render properly.
  setTimeout(() => w.print(), 600);
}

/* Brother QL-800 · DK-11201 (29 × 90 mm die-cut). One label per page, landscape 90 × 29 mm.
   In the print dialog choose "Brother QL-800", paper "29mm x 90mm", margins none, scale 100%. */
export function printBrotherLabels(items) {
  const w = window.open("", "_blank", "width=700,height=600");
  if (!w) return;
  const svgOf = (v) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    try { JsBarcode(svg, v, { format: "CODE128", width: 1, height: 18, margin: 0, displayValue: false }); return svg.outerHTML; } catch { return ""; }
  };
  const labels = items.map((i) => `
    <div class="lbl">
      <div class="loc">${esc(i.location || "—")}</div>
      <div class="body">
        <div class="name">${esc(i.name || "")}</div>
        ${i.name_ar ? `<div class="name_ar" dir="rtl">${esc(i.name_ar)}</div>` : ""}
        <div class="sku"><span class="k">CODE</span> ${esc(i.sku || "")}</div>
        <div class="foot">
          <div class="bc">${svgOf(i.barcode || i.sku)}</div>
          <div class="brand">V12 GARAGE</div>
        </div>
      </div>
    </div>`).join("");
  loadHtmlIntoWindow(w, `<!doctype html><html><head><title>QL-800 · ${items.length} labels</title>
    <style>
      @page { size: 90mm 29mm; margin: 0; }
      html, body { margin: 0; padding: 0; background: #fff; color: #000; font-family: Helvetica, Arial, sans-serif; }
      .toolbar { text-align:center; padding: 8px; font-size: 12px; color:#444; }
      .toolbar button { padding:6px 14px; font-size:12px; border:1px solid #333; background:#fff; border-radius:4px; cursor:pointer; margin-left:8px }
      .lbl { width: 90mm; height: 29mm; box-sizing: border-box; overflow: hidden; page-break-after: always; break-after: page; display:flex; }
      .loc { width: 20mm; flex: none; background:#000; color:#fff; display:flex; align-items:center; justify-content:center; text-align:center; font-weight: 900; font-size: 20pt; letter-spacing: -.02em; line-height: 1; padding: 0 1mm; word-break: break-all; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .body { flex: 1; min-width: 0; padding: 1.5mm 2mm 1mm 2.5mm; display:flex; flex-direction:column; }
      .name { font-size: 11.5pt; font-weight: 800; line-height: 1.08; max-height: 2.2em; overflow: hidden; letter-spacing: -.01em; }
      .name_ar { font-size: 9pt; font-weight: 700; line-height: 1.1; }
      .sku { font-family: "Courier New", monospace; font-size: 12pt; font-weight: 700; margin-top: auto; white-space: nowrap; overflow:hidden; }
      .sku .k { font-family: Helvetica, Arial, sans-serif; font-size: 6.5pt; font-weight: 700; color:#555; letter-spacing:.1em; vertical-align: middle; }
      .foot { display:flex; align-items:flex-end; justify-content:space-between; gap: 2mm; margin-top: .6mm; }
      .bc svg { height: 5mm; width: auto; max-width: 45mm; display:block; }
      .brand { font-size: 6pt; font-weight: 800; letter-spacing: .16em; color:#444; }
      @media screen { .lbl { border: 1px dashed #bbb; margin: 4px auto; } }
      @media print { .no-print { display: none; } }
    </style></head><body>
    <div class="toolbar no-print">${items.length} × 29×90 mm (DK-11201) — kies printer Brother QL-800, papier "29mm x 90mm", marges: geen, schaal 100%<button onclick="window.print()">🖨 Print</button></div>
    ${labels}</body></html>`);
  setTimeout(() => w.print(), 400);
}
